module.exports = {
  BASE_URL: BASE_URL,
  api: {
    contacto: BASE_URL + "api/contacto/",
    tiposdocumentos: BASE_URL + "api/tiposdocumentos/",
    catalogo: BASE_URL + "catalogo/",
    resumenCuenta: BASE_URL + "perfil/resumencuenta/",
    search: BASE_URL + "api/search/",
    producto: BASE_URL + "api/producto/",
    productos: BASE_URL + "api/productos/",
    productosOferta: BASE_URL + "api/productosOferta/",
    exportPrecios: BASE_URL + "api/export/precios/",
    marcas: BASE_URL + "api/marcas/",
    lineas: BASE_URL + "api/lineas/",
    rubros: BASE_URL + "api/rubros/",
    modelos: BASE_URL + "api/rubros/@@/modelos",
    solicitudes: BASE_URL + "api/solicitudes/productos/@@/",
    menu: BASE_URL + "api/menu/",
    cart: BASE_URL + "api/cart/",
    generatecart: BASE_URL + "api/generatecart/",
    mercadopago: BASE_URL + "api/mercadopago/procesar-pago/",
    retrymercadopago: BASE_URL + "api/mercadopago/retry-procesar-pago/",
    pedidos: BASE_URL + "api/pedidos/",
    pagosMP: BASE_URL + "api/mercadopago/",
    pedidosGenerar: BASE_URL + "api/generarpedido/",
    random: BASE_URL + "api/random/productos/",
    auth: {
      sigletonToken: BASE_URL + "auth/generateSingletonToken/",
      login: BASE_URL + "auth/login/",
      logoff: BASE_URL + "auth/logoff/",
      check: BASE_URL + "auth/check/",
      profile: BASE_URL + "auth/profile/",
      recentqueries: BASE_URL + "auth/recentqueries/"
    },
    perfil: {
      editar: BASE_URL + "api/perfil/"
    },
    transportesAsociados: BASE_URL + "perfil/transportesAsociados/",
    lastcartitem: BASE_URL + "perfil/lastCartItem/",
    setcartitem: BASE_URL + "perfil/saveCartItems/",
    formasdepago: BASE_URL + "api/formasdepago/",
    listadepreciosfichero: BASE_URL + "perfil/listadepreciosfichero/",
    downloadlistadepreciosfichero: BASE_URL + "perfil/listadepreciosfichero/@@/",
    }
};



// WEBPACK FOOTER //
// ./src/api/api.js